var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M25.8 8.3a2.1 2.1 0 1 1-4.2 0 2.1 2.1 0 0 1 4.2 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16 23a7 7 0 1 0 0-14 7 7 0 0 0 0 14m0-2.8a4.2 4.2 0 1 0 0-8.4 4.2 4.2 0 0 0 0 8.4",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2 15.44c0-4.704 0-7.057.916-8.854a8.4 8.4 0 0 1 3.67-3.67C8.383 2 10.736 2 15.44 2h1.12c4.704 0 7.057 0 8.854.916a8.4 8.4 0 0 1 3.67 3.67C30 8.383 30 10.736 30 15.44v1.12c0 4.704 0 7.057-.916 8.854a8.4 8.4 0 0 1-3.67 3.67C23.617 30 21.264 30 16.56 30h-1.12c-4.704 0-7.057 0-8.854-.916a8.4 8.4 0 0 1-3.67-3.67C2 23.617 2 21.264 2 16.56zM15.44 4.8h1.12c2.398 0 4.029.002 5.29.105 1.227.1 1.854.282 2.292.505a5.6 5.6 0 0 1 2.448 2.448c.223.438.405 1.065.505 2.293.103 1.26.105 2.89.105 5.289v1.12c0 2.398-.002 4.029-.105 5.29-.1 1.227-.282 1.854-.505 2.292a5.6 5.6 0 0 1-2.448 2.448c-.438.223-1.065.405-2.293.505-1.26.103-2.89.105-5.289.105h-1.12c-2.398 0-4.029-.002-5.29-.105-1.227-.1-1.854-.282-2.292-.505a5.6 5.6 0 0 1-2.448-2.448c-.223-.438-.405-1.065-.505-2.293-.103-1.26-.105-2.89-.105-5.289v-1.12c0-2.398.002-4.029.105-5.29.1-1.227.282-1.854.505-2.292A5.6 5.6 0 0 1 7.858 5.41c.438-.223 1.065-.405 2.293-.505 1.26-.103 2.89-.105 5.289-.105",
    clipRule: "evenodd"
  })));
};
export default SvgInstagram;